var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.213,
    height: 11.55,
    viewBox: "0 0 14.213 11.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-5083.261 -32.225)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "white_background",
    "data-name": "white background",
    d: "M5096.019,35.1c.008.125.008.25.008.377a8.24,8.24,0,0,1-8.3,8.3v0a8.242,8.242,0,0,1-4.469-1.307,5.744,5.744,0,0,0,.694.042,5.851,5.851,0,0,0,3.621-1.251,2.918,2.918,0,0,1-2.724-2.025,2.9,2.9,0,0,0,1.316-.05,2.917,2.917,0,0,1-2.339-2.858v-.037a2.9,2.9,0,0,0,1.324.365,2.921,2.921,0,0,1-.9-3.894,8.276,8.276,0,0,0,6.01,3.047,2.919,2.919,0,0,1,4.969-2.66,5.844,5.844,0,0,0,1.852-.708,2.922,2.922,0,0,1-1.282,1.613,5.808,5.808,0,0,0,1.675-.459A5.944,5.944,0,0,1,5096.019,35.1Z",
    fill: "#98a9b8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0b40fc7dd4522bd6eb8e91a19883a2d1.svg";
export { ForwardRef as ReactComponent };